import React, { useEffect, useState } from "react";
import T from "src/ipm-shared/Utils/Intl";
import { FORM } from "src/ipm-shared/store/model/Payee/const";
import { ENTITY } from "src/ipm-shared/store/model/Payment/const";
import ExpandBox from "../../ExpandBox";
import IconUpload from "src/bepaid/assets/images/common/icon_upload.svg";
import IconArrowDown from "src/bepaid/assets/images/common/drop_down_arrow_grey.svg";
import FormStyles from "src/bepaid/components/Form/CommonForm.module.scss";
import InputFile from "src/bepaid/components/Form/controls/InputFile";
import InputFileDropZone from "src/bepaid/components/Form/controls/InputFile/components/InputFileDropZone";
import Form from "src/bepaid/components/Form";
import InputText from "src/bepaid/components/Form/controls/InputText";
import Select from "src/bepaid/components/Form/controls/Select";
import Image from "src/bepaid/components/Image";
import Checkbox from "src/bepaid/components/Form/controls/Checkbox";

import CurrencyUtil from "src/ipm-shared/Utils/Currency";
import FileUtils from "src/ipm-shared/Utils/Files";
import _isEmpty from "lodash-es/isEmpty";
import _get from "lodash-es/get";
import { useMakePaymentUrlParams } from "src/bepaid/pages/Payments/hooks";

import styles from "../../ExpandBox/ExpandBox.module.scss";
import SelectGroup from "src/bepaid/components/SelectGroup";
import classNames from "classnames";
import UtilityItemStyles from "./UtilityItem.module.scss";

const UtilityForm = ({
  accountCountryCode,
  accountCurrencyId,
  payee,
  validateAmount,
  checkValidNoteToRecipient,
  filesControl,
  selectPayees,
  extraPayeeUid,
  setExtraPayeeValue,
  formState,
  removeControlPattern,
  list
}: any) => {
  const [allowEdit, setAllowEdit] = useState(false);
  const { entity } = useMakePaymentUrlParams();
  const [defaultValues, setDefaultValues] = useState<any>();
  const [key, setKey] = useState<any>();
  const HKD = CurrencyUtil.convertFromCurrencyCode("HKD");
  const USD = CurrencyUtil.convertFromCurrencyCode("USD");

  const filterUtilitys = (list || []).map((p: any) => ({
    value: p.id,
    label: p.name,
    children: []
  }));

  const [supportingDocuments, setSupportingDocuments] = useState<any>({
    fetch: false,
    value: []
  });

  const setAmountValue = (id: number, e: any) => {
    const amount = e.target.value;
    if (extraPayeeUid) {
      setExtraPayeeValue(id, extraPayeeUid, "defaultAmount", amount);
    }
    validateAmount({
      amount: parseFloat(amount) * 100,
      form: FORM,
      fieldName: name,
      isWallet: true,
      bePaid: true
    });
  };

  const onChangeComments = (id: number, e: any) => {
    const comment = e.target.value;
    checkValidNoteToRecipient(comment, e.target.name, false, entity, () => {
      if (extraPayeeUid) {
        setExtraPayeeValue(id, extraPayeeUid, "defaultComments", comment);
      }
    });
  };

  const onChangeUtility = (value: string, _: string) => {
    setAllowEdit(false);
    if (!_isEmpty(payee)) {
      removeControlPattern(new RegExp(`${payee?.id}`));
    }
    const ids = [value];
    selectPayees({ purpose: ENTITY.UTILITY, ids, removedIds: "all" });
  };

  useEffect(() => {
    if (!_isEmpty(filesControl)) {
      const data = FileUtils.getInfoFromKeys(
        _get(filesControl, `${payee?.id}`, [])
      );
      setSupportingDocuments({
        ...supportingDocuments,
        fetch: true,
        value: data
      });
    } else {
      setSupportingDocuments({
        ...supportingDocuments,
        fetch: true
      });
    }
  }, []);

  useEffect(() => {
    if (payee?.id) {
      setKey(payee.id);
      setDefaultValues({
        accountNumber: _get(payee, "accountNumber", ""),
        defaultAmount: _get(formState, `supplier_amount_utility.value`, ""),
        defaultComments: _get(formState, `supplier_comments_utility.value`, ""),
        bankId: _get(payee, "bankId", null)
      });
    }
  }, [payee]);

  const amountInputTextProps = {
    labelNoColon: true,
    name: extraPayeeUid
      ? `supplier_amount_${payee?.id}_${extraPayeeUid}`
      : payee?.id
      ? `supplier_amount_${payee?.id}`
      : `supplier_amount_utility`,
    placeholder: `0.00`,
    label: "Amount",
    prefix: CurrencyUtil.convertFromId(accountCurrencyId as number).$,
    form: FORM,
    pattern: "__MONEY__",
    defaultValue: extraPayeeUid
      ? null
      : payee?.id
      ? defaultValues?.defaultAmount
      : null,
    revertValueOnMount: true,
    reserveValueOnUnmount: true,
    onChange: setAmountValue.bind(null, payee?.id)
  };

  const accountNameInputTextProps = {
    name: extraPayeeUid
      ? `supplier_bank_account_holder_name_${payee?.id}_${extraPayeeUid}`
      : payee?.id
      ? `supplier_bank_account_holder_name_${payee?.id}`
      : "supplier_bank_account_holder_name_utility",
    placeholder: "Utility account holder name",
    label: "Utility account holder name",
    form: FORM,
    maxlength: 35,
    pattern: "__STATEMENT__",
    revertValueOnMount: true,
    reserveValueOnUnmount: true,
    defaultValue: extraPayeeUid
      ? ""
      : payee?.id
      ? _get(payee, "international.bankAccountHolderName", "")
      : ""
  };

  const accountNumberInputTextProps = {
    name: extraPayeeUid
      ? `supplier_comments_${payee?.id}_${extraPayeeUid}`
      : payee?.id
      ? `supplier_comments_${payee?.id}`
      : "supplier_comments_utility",
    placeholder: "Utility account number",
    form: FORM,
    label: "Utility account number",
    defaultValue: extraPayeeUid
      ? ""
      : payee?.id
      ? defaultValues?.defaultComments
      : "",
    reserveValueOnUnmount: true,
    revertValueOnMount: true,
    onChange: onChangeComments.bind(null, payee?.id)
  };

  const supportingDocumentsInputFileProps = {
    formItemLabel: (
      <p className={styles.invoiceFieldInstruction}>
        <p>Your utility document:</p>
        <span className={UtilityItemStyles.inputFileHelperText}>
          Please upload a clear copy of your utility bill with the{" "}
          <b>FPS QR code visible and unobstructed</b>.
        </span>
      </p>
    ),
    name: `supporting_documents_${
      extraPayeeUid
        ? `${payee?.id}_${extraPayeeUid}`
        : payee?.id
        ? payee?.id
        : ENTITY.UTILITY
    }`,
    btnClassName: FormStyles.boxShadow,
    allowedFileTypes: ["jpg", "png", "heic", "pdf"],
    purpose: "bank_statement",
    form: FORM,
    label: "Upload Utility",
    icon: IconUpload,
    canDrag: true,
    multiple: true,
    renderComponent: InputFileDropZone,
    revertValueOnMount: true,
    reserveValueOnUnmount: true,
    syncUiStateWithRedux: true
  };

  return (
    <Form requiredMark={false} layout="vertical">
      {!extraPayeeUid && (
        <>
          <Select
            form={FORM}
            name={"utility_id"}
            placeholder={"Utility provider"}
            label={"Utility provider"}
            options={filterUtilitys}
            showSearch={false}
            allowClear={false}
            suffixIcon={<Image src={IconArrowDown} />}
            onChange={onChangeUtility}
            defaultValue={_get(payee, "id")}
            reserveValueOnUnmount={true}
            revertValueOnMount={true}
            description={
              payee && (
                <Checkbox
                  wrapperClassName={classNames(
                    styles.checkboxForm2,
                    UtilityItemStyles.optInCheckbox
                  )}
                  name={"supplier_opt_in_utility"}
                  presentedValue="checked"
                  defaultChecked={true}
                  form={FORM}
                  label={T.transl("INTEND_MULTIPLE_PAYMENTS_LABEL")}
                  reserveValueOnUnmount={true}
                  revertValueOnMount={true}
                />
              )
            }
          />
          {_get(formState, `utility_id.value`) === "0" && (
            <InputText
              name={`utility_provider_name_${
                extraPayeeUid
                  ? `${payee?.id}_${extraPayeeUid}`
                  : payee?.id
                  ? payee?.id
                  : ENTITY.UTILITY
              }`}
              label="Utility Provider Name"
              placeholder="Enter Utility Provider"
              form={FORM}
              revertValueOnMount={true}
              reserveValueOnUnmount={true}
            />
          )}
        </>
      )}
      {_isEmpty(payee) && (
        <>
          <div className={styles.inputMoney}>
            <div hidden={true}>
              {accountCountryCode === "HK" && (
                <SelectGroup
                  name={"hk_multiple_currency_id"}
                  form={FORM}
                  className={styles.inputMoneyCustomSelect}
                  options={[
                    { label: HKD.$, value: HKD.id },
                    { label: USD.$, value: USD.id }
                  ]}
                  defaultValue={HKD.id}
                />
              )}
            </div>
            <InputText {...amountInputTextProps} />
          </div>
          <InputText {...accountNameInputTextProps} />
          <InputText {...accountNumberInputTextProps} />
          {supportingDocuments.fetch && (
            <InputFile {...supportingDocumentsInputFileProps} />
          )}
        </>
      )}
      {!_isEmpty(payee) && (
        <div key={key}>
          <div className={styles.inputMoney}>
            <div hidden={true}>
              {accountCountryCode === "HK" && (
                <SelectGroup
                  name={"hk_multiple_currency_id"}
                  form={FORM}
                  className={styles.inputMoneyCustomSelect}
                  options={[
                    { label: HKD.$, value: HKD.id },
                    { label: USD.$, value: USD.id }
                  ]}
                  defaultValue={HKD.id}
                />
              )}
            </div>
            <InputText {...amountInputTextProps} />
          </div>
          <InputText {...accountNameInputTextProps} />
          <InputText {...accountNumberInputTextProps} />
          <Checkbox
            hidden={!allowEdit}
            name={`confirm_account_number_${
              extraPayeeUid
                ? `${payee?.id}_${extraPayeeUid}`
                : payee?.id
                ? payee?.id
                : ENTITY.UTILITY
            }`}
            presentedValue="checked"
            singleSelect={true}
            defaultChecked={!allowEdit}
            wrapperClassName={styles.checkboxForm}
            form={FORM}
            label={
              "I confirm these bank details are relevant to my utility provider."
            }
          />
          {supportingDocuments.fetch && (
            <InputFile {...supportingDocumentsInputFileProps} />
          )}
        </div>
      )}
    </Form>
  );
};

const View = (props: any) => {
  return (
    <ExpandBox
      name={props.payee?.name}
      hideExpandBtn={true}
      onlyShowChildren={true}
      onClickDelete={props.onClickDeletePayee}
    >
      <UtilityForm {...props} />
    </ExpandBox>
  );
};

export default View;
